// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SiteModelsSiteRequestModel {
    'description': string;
    'nickName': string;
    'siteNote': string;
    'npi': string;
    'stateTaxId': string;
    'billingCode': string;
    'isSitePayable': boolean;
    'isActive': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteModelsSiteRequestModel>> = [
        {
            "name":     "description",
            "baseName": "description",
            "type":     "string"
        },
        {
            "name":     "nickName",
            "baseName": "nickName",
            "type":     "string"
        },
        {
            "name":     "siteNote",
            "baseName": "siteNote",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "stateTaxId",
            "baseName": "stateTaxId",
            "type":     "string"
        },
        {
            "name":     "billingCode",
            "baseName": "billingCode",
            "type":     "string"
        },
        {
            "name":     "isSitePayable",
            "baseName": "isSitePayable",
            "type":     "boolean"
        },
        {
            "name":     "isActive",
            "baseName": "isActive",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return SiteModelsSiteRequestModel.attributeTypeMap;
    }
}
